import {
  Question,
  isSingleChoiceQuestion,
  isSliderQuestion,
} from "../../types/Question";
import { SingleChoiceQuestion } from "./SingleChoiceQuestion";
import { AnswerOptionId } from "../../types/AnswerOption";
import { SliderQuestion } from "./SliderQuestion";
import { useDataTranslation } from "../../../../lib/i18n/data";

type UniversalQuestionProps = {
  question: Question;
  subtitle?: string;
  onSelect: (answerId: AnswerOptionId) => void;
  gift?: boolean;
};

export const UniversalQuestion = ({
  question,
  subtitle,
  onSelect,
  gift,
}: UniversalQuestionProps) => {
  const { tData } = useDataTranslation();

  const translatedQuestion = tData('questions', question.id, 'question', question.question);
  const translatedOptions = question.options.map((option) => ({
    ...option,
    label: tData('answers', option.id, 'label', option.label),
    description: option.description
      ? tData('answers', option.id, 'description', option.description)
      : option.description,
  }));

  if (isSingleChoiceQuestion(question)) {
    return (
      <SingleChoiceQuestion
        subtitle={subtitle}
        question={translatedQuestion}
        options={translatedOptions}
        onSelect={onSelect}
        gift={gift}
      />
    );
  }

  if (isSliderQuestion(question)) {
    const translatedMinLabel = tData('questions', question.id, 'minLabel', question.minLabel);
    const translatedMaxLabel = tData('questions', question.id, 'maxLabel', question.maxLabel);

    return (
      <SliderQuestion
        subtitle={subtitle}
        question={translatedQuestion}
        minLabel={translatedMinLabel}
        maxLabel={translatedMaxLabel}
        options={question.options.map((option) => option.label)}
        onSelect={(selectedLabel) => {
          const selectedOption = question.options.find(
            (option) => option.label === selectedLabel
          );
          if (selectedOption) {
            onSelect(selectedOption.id);
          }
        }}
      />
    );
  }

  return null;
};
